exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-7c658f47] {\n  text-decoration: none;\n}\n.claim-closed[data-v-7c658f47] {\n  background-color: #2962ff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: #fff;\n  border-radius: 4px;\n  padding: 14px;\n  height: 52px;\n}\n.list-box-status[data-v-7c658f47] {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.list-box-header[data-v-7c658f47] {\n  min-height: 66px;\n}\n.role-roles[data-v-7c658f47] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.full-name[data-v-7c658f47] {\n  font-weight: 500;\n  font-size: 16px;\n  color: #4c5669;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c658f47","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/UserRoles/SettingsUserRolesBlock.vue
// module id = UNus
// module chunks = 0